import { alpha } from "@mui/material/styles";
import { UIThemeOptions } from "../../components";

export default {
  spacing: 8,
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  direction: "ltr",
  // Soft, diffuse elevation scale — lighter than stock MUI for a flatter, modern surface language
  shadows: [
    "none",
    "0px 1px 2px rgba(16,24,40,0.06), 0px 1px 3px rgba(16,24,40,0.10)",
    "0px 2px 4px rgba(16,24,40,0.06), 0px 2px 6px rgba(16,24,40,0.10)",
    "0px 3px 6px rgba(16,24,40,0.07), 0px 3px 8px rgba(16,24,40,0.10)",
    "0px 4px 8px -2px rgba(16,24,40,0.10), 0px 2px 4px -2px rgba(16,24,40,0.06)",
    "0px 6px 10px -2px rgba(16,24,40,0.10), 0px 3px 6px -3px rgba(16,24,40,0.07)",
    "0px 8px 12px -3px rgba(16,24,40,0.10), 0px 4px 6px -4px rgba(16,24,40,0.07)",
    "0px 9px 14px -3px rgba(16,24,40,0.10), 0px 4px 7px -4px rgba(16,24,40,0.07)",
    "0px 10px 16px -4px rgba(16,24,40,0.11), 0px 4px 8px -4px rgba(16,24,40,0.07)",
    "0px 11px 18px -4px rgba(16,24,40,0.11), 0px 5px 9px -5px rgba(16,24,40,0.07)",
    "0px 12px 20px -4px rgba(16,24,40,0.11), 0px 5px 10px -5px rgba(16,24,40,0.08)",
    "0px 13px 22px -5px rgba(16,24,40,0.12), 0px 6px 11px -5px rgba(16,24,40,0.08)",
    "0px 14px 24px -5px rgba(16,24,40,0.12), 0px 6px 12px -6px rgba(16,24,40,0.08)",
    "0px 15px 26px -5px rgba(16,24,40,0.12), 0px 7px 13px -6px rgba(16,24,40,0.08)",
    "0px 16px 28px -6px rgba(16,24,40,0.13), 0px 7px 14px -6px rgba(16,24,40,0.08)",
    "0px 17px 30px -6px rgba(16,24,40,0.13), 0px 8px 15px -7px rgba(16,24,40,0.09)",
    "0px 18px 32px -6px rgba(16,24,40,0.13), 0px 8px 16px -7px rgba(16,24,40,0.09)",
    "0px 19px 34px -7px rgba(16,24,40,0.14), 0px 9px 17px -7px rgba(16,24,40,0.09)",
    "0px 20px 36px -7px rgba(16,24,40,0.14), 0px 9px 18px -8px rgba(16,24,40,0.09)",
    "0px 21px 38px -7px rgba(16,24,40,0.14), 0px 10px 19px -8px rgba(16,24,40,0.10)",
    "0px 22px 40px -8px rgba(16,24,40,0.15), 0px 10px 20px -8px rgba(16,24,40,0.10)",
    "0px 23px 42px -8px rgba(16,24,40,0.15), 0px 11px 21px -9px rgba(16,24,40,0.10)",
    "0px 24px 44px -8px rgba(16,24,40,0.15), 0px 11px 22px -9px rgba(16,24,40,0.10)",
    "0px 25px 46px -9px rgba(16,24,40,0.16), 0px 12px 23px -9px rgba(16,24,40,0.11)",
    "0px 26px 48px -9px rgba(16,24,40,0.16), 0px 12px 24px -10px rgba(16,24,40,0.11)",
  ],
  typography: {
    htmlFontSize: 16,
    fontFamily: "'Open Sans', sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 700,
      fontSize: "1.75rem",
      lineHeight: 1.25,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.25,
      letterSpacing: "-0.01em",
    },
    h3: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: 1.35,
    },
    h5: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "0.9375rem",
      lineHeight: 1.5,
    },
    subtitle1: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.75,
    },
    subtitle2: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.57,
    },
    body1: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "0.875rem",
      lineHeight: 1.43,
    },
    button: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "0.875rem",
      lineHeight: 1.75,
      textTransform: "none",
    },
    caption: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 1.66,
    },
    overline: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 2.66,
      textTransform: "uppercase",
    },
  },
  shape: {
    borderRadius: 10,
  },
  transitions: {
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Thin, unobtrusive scrollbars so horizontally scrollable tables read as scrollable
        "*::-webkit-scrollbar": {
          width: 8,
          height: 8,
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(39,29,62,0.22)",
          borderRadius: 8,
        },
        "*::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "rgba(39,29,62,0.35)",
        },
        "*::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(39,29,62,0.22) transparent",
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        // Visible keyboard focus indicator (WCAG 2.4.7) — derived from the brand primary at
        // runtime, so it works for every tenant's color scheme.
        root: ({ theme }) => ({
          "&.Mui-focusVisible": {
            outline: `3px solid ${alpha(theme.palette.primary.main, 0.5)}`,
            outlineOffset: 2,
          },
        }),
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: "1px solid #e9e9ec",
          backgroundImage: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 10,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: "2rem",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: 10,
          ...(ownerState.variant === "filled" && {
            color: "#fff",
          }),
        }),
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: "24px !important",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        color: "inherit",
      },
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: "0.875rem",
          borderRadius: 8,
          paddingTop: 7,
          paddingBottom: 7,
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedSecondary: {
          color: "#ffffff",
        },
        sizeLarge: {
          fontSize: "0.875rem",
          padding: "12px 24px",
        },
        sizeSmall: {
          padding: "3px 12px",
          fontSize: "0.875rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          // Inputs sit on the grey page surface — give them a solid paper background
          // so they don't read as grey-on-grey.
          backgroundColor: "#fff",
        },
        input: {
          "&.Mui-disabled": {
            backgroundColor: "#f8f7f9",
            WebkitTextFillColor: "rgba(39,29,62,0.54)",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: "inherit",
          borderBottomColor: "#e9e9ec",
        },
        head: {
          color: "rgba(39,29,62,0.54)",
          fontSize: ".75rem",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          paddingTop: 12,
          paddingBottom: 12,
          paddingRight: 0,
          paddingLeft: "16px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          border: "none",
        },
      },
    },
    //@ts-ignore // styles table head when sorting is enabled
    MUIDataTableHeadCell: {
      styleOverrides: {
        contentWrapper: {
          display: "inline",
          width: "100%",
        },
        sortAction: {
          fontSize: ".75rem",
        },
        fixedHeader: {
          top: "-1px",
        },
      },
    },
    MUIDataTableSelectCell: {
      styleOverrides: {
        paddingCheckbox: {
          border: "none",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "rgba(39,29,62,0.02)",
          },
          "&.Mui-selected": {
            background: "none !important",
          },
          "&.Mui-selected:hover": {
            background: "none !important",
          },
        },
      },
    },
  },
  mixins: {
    toolbar: {
      minHeight: 56,
      "@media (min-width:0px) and (orientation: landscape)": {
        minHeight: 48,
      },
      "@media (min-width:600px)": {
        minHeight: 64,
      },
    },
  },
  palette: {
    primary: {
      main: "#7a5aff",
    },
    secondary: {
      main: "#4ec4b0",
    },
    tertiary: {
      main: "#524b65",
    },
    success: {
      light: "#e0f8e5",
      main: "#51b063",
      dark: "#3d844a",
      contrastText: "#fff",
    },
    error: {
      light: "#fee4e2",
      main: "#d92d20",
      dark: "#b42318",
      contrastText: "#fff",
    },
    warning: {
      light: "#fef0c7",
      main: "#f79009",
      dark: "#b54708",
      contrastText: "#fff",
    },
    info: {
      light: "#e8f4fd",
      main: "#2e90fa",
      dark: "#175cd3",
      contrastText: "#fff",
    },
    text: {
      primary: "rgba(39,29,62,0.87)",
      secondary: "rgba(39,29,62,0.54)",
      disabled: "rgba(39,29,62,0.38)",
    },
    common: {
      black: "#000000",
      white: "#ffffff",
    },
    grey: {
      "50": "#f8f7f9",
      "100": "#e9e9ec",
      "200": "#d3d2d7",
      "300": "#a9a5b2",
      "400": "#7d788c",
      "500": "#524b65",
      "600": "#271d3e",
      "700": "#1a142b",
      "800": "#140f1e",
      "900": "#000000",
      A100: "#d5d5d5",
      A200: "#aaaaaa",
      A400: "#303030",
      A700: "#616161",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    divider: "rgba(39,29,62,0.12)",
    background: {
      paper: "#fff",
      default: "#f6f7f9",
    },
    action: {
      active: "rgba(39,29,62,0.38)",
      hover: "rgba(39,29,62,0.02)",
      hoverOpacity: 0.04,
      selected: "rgba(39,29,62,0.01)",
      selectedOpacity: 0.08,
      disabled: "rgba(39,29,62,0.54)",
      disabledBackground: "rgba(39,29,62,0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12,
    },
  },
} as UIThemeOptions;
